import { Component, Inject, Input } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ButtonComponent } from '../../inputs/button/button.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface NewModalConfirmationData {
  title: string;
  subtitle?: string;
  icon?: string;
  description: string;
  showConfirmMessage: boolean;
  cancelButtonName?: string;
  confirmButtonName?: string;
}
@Component({
  selector: 'new-modal-confirmation',
  standalone: true,
  imports: [SharedModule, ButtonComponent],
  templateUrl: './new-modal-confirmation.component.html',
  styleUrl: './new-modal-confirmation.component.scss'
})
export class NewModalConfirmationComponent {

  constructor(
    public dialogRef: MatDialogRef<NewModalConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewModalConfirmationData,
    private sanitizer: DomSanitizer
  ) { }

  get sanatizeMessage(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.data?.description || '')
  }

  onClose(res: boolean) {
    this.dialogRef?.close(res)
  }
}
